module.exports = __webpack_public_path__ + "c1716c4a5a88c4f3f58e764aaf1e7965.svg";